// Typed client for the Studio copilot API (/v1/studio/assistant/*).
// See app/api/studio_assistant_router.py. Conversation state is client-held:
// each turn sends the visible history plus the current draft.

import { apiRequest } from "./http";
import type { CharacterProfile } from "../types/guide";
import type { Skill } from "../types/skill";

export interface AssistantModel {
  id: string;
  provider: "google" | "anthropic";
}

export interface AssistantMessage {
  role: "user" | "assistant";
  content: string;
}

export interface PatchProposal {
  kind: "guide" | "skill";
  patch: Record<string, unknown>;
  rationale: string;
}

export interface ToolTraceEntry {
  tool: string;
  summary: string;
}

export interface AssistantContext {
  kind: "guide" | "skill";
  id: string | null;
  draftProfile?: CharacterProfile;
  draftSkill?: Skill;
}

export interface AssistantReply {
  message: string;
  proposals: PatchProposal[];
  toolTrace: ToolTraceEntry[];
  model: string;
}

export const listAssistantModels = () =>
  apiRequest<{ models: AssistantModel[]; default: string }>("/studio/assistant/models");

export const sendAssistantTurn = (
  model: string | null,
  context: AssistantContext,
  messages: AssistantMessage[],
) =>
  apiRequest<AssistantReply>("/studio/assistant/chat", {
    method: "POST",
    body: { model, context, messages },
  });
